import React from "react";
import sp from "../../assets/images/content/sp.jpg";
import events from "../../assets/images/updates/upcoming.jpg";
import snip1 from "../../assets/images/updates/snip1.JPG";
import snip2 from "../../assets/images/updates/snip2.JPG";
import kcgsports from "../../assets/images/updates/kcg2026.jpg";
import kcgsportsresults from "../../assets/images/updates/sportsresults2026.jpg";
import thanks from "../../assets/images/updates/thanksgiving2026.jpg";

const UpdatesBody = () => {
  return (
    <section className="section-spacing-80 no-padding-top">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-content white-bg box-shadow width-600 relative margin-auto border-radius-2">
              <div className="section-body minus-margin-top-100">
                <div className="padding-16 center">
                  <div className="updates-container">
                    <div className="updates-card box-shadow">
                      <div className="updates-head center">
                        <h3 className="uppercase green">
                          THANKSGIVING & CELEBRATION
                        </h3>
                      </div>
                      <div className="updates-image">
                        <img src={thanks} alt="Thanksgiving" />
                      </div>
                      <div className="updates-details">
                        <h4 className="uppercase green margin-top-bottom-10">
                          Details
                        </h4>
                        <div className="updates-details-inner">
                          <ul>
                            <li>
                              Date: <strong>13th August 2026</strong>
                            </li>
                            <li>
                              Venue:{" "}
                              <strong>
                                Kampala City Grammar School, Mutundwe
                              </strong>
                            </li>
                          </ul>
                          <p className="center">
                            Please come we give thanks and celebrate the
                            homecoming of our champions.
                          </p>
                          <a
                            href="https://instagram.com/kampala_city_grammar_school"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            KCG School on Instagram
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="updates-card box-shadow">
                      <div className="updates-head center">
                        <h3 className="uppercase green">
                          KCG SPORTS DAY 2026 RESULTS
                        </h3>
                      </div>
                      <div className="updates-image">
                        <img
                          src={kcgsportsresults}
                          alt="KCG Sports Day 2026 RESULTS"
                        />
                      </div>
                      <div className="updates-details">
                        <h4 className="uppercase green margin-top-bottom-10">
                          Details
                        </h4>
                        <div className="updates-details-inner">
                          <ul>
                            <li>
                              Date: <strong>8th August 2026</strong>
                            </li>
                            <li>
                              Venue:{" "}
                              <strong>
                                Kitebi Primary School, Kitebi, Kampala
                              </strong>
                            </li>
                          </ul>
                          <p className="center">
                            Well done to all our champions and thank you for
                            your presence to cheer them up.
                          </p>
                          <a
                            href="https://instagram.com/kampala_city_grammar_school"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            KCG School on Instagram
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="updates-card box-shadow">
                      <div className="updates-head center">
                        <h3 className="uppercase green">KCG SPORTS DAY 2026</h3>
                      </div>
                      <div className="updates-image">
                        <img src={kcgsports} alt="KCG Sports Day 2026" />
                      </div>
                      <div className="updates-details">
                        <h4 className="uppercase green margin-top-bottom-10">
                          Details
                        </h4>
                        <div className="updates-details-inner">
                          <ul>
                            <li>
                              Date: <strong>8th August 2026</strong>
                            </li>
                            <li>
                              Venue:{" "}
                              <strong>
                                Kitebi Primary School, Kitebi, Kampala
                              </strong>
                            </li>
                          </ul>
                          <p className="center">
                            Come, Cheer, Suport and be Part of Action.
                          </p>
                          <a
                            href="https://instagram.com/kampala_city_grammar_school"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            KCG School on Instagram
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="updates-card box-shadow">
                      <div className="updates-head center">
                        <h3 className="uppercase green">
                          {" "}
                          CALENDAR OF ACTIVITIES FOR 2ND TERM 2025{" "}
                        </h3>
                      </div>
                      <div className="updates-image">
                        <img
                          src={snip1}
                          alt="CALENDAR OF ACTIVITIES FOR SECOND TERM 2025"
                        />
                        <img
                          src={snip2}
                          alt="CALENDAR OF ACTIVITIES FOR SECOND TERM 2025"
                        />
                      </div>
                    </div>
                    <div className="updates-card box-shadow">
                      <div className="updates-head center">
                        <h3 className="uppercase green">
                          {" "}
                          UPCOMING SCHOOL EVENTS TO END OF SCHOOL 3RD TERM
                          2024{" "}
                        </h3>
                      </div>
                      <div className="updates-image">
                        <img
                          src={events}
                          alt="Spelling Bee Competitions 2023"
                        />
                      </div>
                      <div className="updates-details">
                        <h4 className="uppercase green margin-top-bottom-10">
                          Details
                        </h4>
                        <div className="updates-details-inner">
                          <ul>
                            <li>
                              Date: <strong>14th October 2024</strong>
                            </li>
                          </ul>
                          <p>
                            The above table outline has the pending school
                            events, please take note of them and participate
                            accordingly. We shall be sharing updates and how
                            they went on our social media pages as well. Thank
                            You!
                          </p>
                          <a
                            href="https://instagram.com/kampala_city_grammar_school"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            KCG School on Instagram
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="updates-card box-shadow">
                      <div className="updates-head center">
                        <h3 className="uppercase green">
                          {" "}
                          Spelling Bee Competitions 2023{" "}
                        </h3>
                      </div>
                      <div className="updates-image">
                        <img src={sp} alt="Spelling Bee Competitions 2023" />
                      </div>
                      <div className="updates-details">
                        <h4 className="uppercase green margin-top-bottom-10">
                          Details
                        </h4>
                        <div className="updates-details-inner">
                          <ul>
                            <li>
                              Date: <strong>23rd July 2023</strong>
                            </li>
                          </ul>
                          <p>
                            Kampala City Grammar School organizes Spelling
                            competitions anually and pupils participate by
                            classes.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpdatesBody;
